"use strict";

/**
 * Events der Kartenaktionen.
 *
 * @enum {string}
 */
gc.gis.map.GCMapSelectInteractionEvent = {
	/**
	 * Wird ausgelöst, wenn ein Feature von der Maus betreten wurde.
	 * @event gc.gis.map.GCMapSelectInteractionEvent#feature:enter
	 */
	ENTER:  'feature:enter',

	/**
	 * Wird ausgelöst, wenn ein Feature von der Maus verlassen wurde.
	 * @event gc.gis.map.GCMapSelectInteractionEvent#feature:leave
	 */
	LEAVE:  'feature:leave',

	/**
	 * Wird ausgelöst, wenn ein Feature angeklickt wurde.
	 * @event gc.gis.map.GCMapSelectInteractionEvent#feature:click
	 */
	CLICK:  'feature:click',
};

/**
 * @classdesc
 * Interface für Kartenaktionen zum Selektieren von Features.
 *
 * @abstract
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.map
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.map.GCMapView} map Karte, der die Interaktion gehört
 * @param {Object} [opt_options] optionale Aufrufoptionen
 */
gc.gis.map.GCMapSelectInteraction = function(map, opt_options)
{
	gc.gis.GCObservable.call(this);

	gc.gis.assert.isInstance(map, gc.gis.map.GCMapView);

	/**
	 * @type {gc.gis.map.GCMapView}
	 */
	this.map = map;
};
gc.gis.map.GCMapSelectInteraction.prototype = Object.create(gc.gis.GCObservable.prototype);

/**
 * Setzt die abfragbaren Layer.
 *
 * @param {gc.gis.layer.GCLayer[]} layers
 */
gc.gis.map.GCMapSelectInteraction.prototype.setLayers = gc.gis.abstractMethod;
